import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=42518fd6&scoped=true"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"
import style0 from "./modify.vue?vue&type=style&index=0&id=42518fd6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42518fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42518fd6')) {
      api.createRecord('42518fd6', component.options)
    } else {
      api.reload('42518fd6', component.options)
    }
    module.hot.accept("./modify.vue?vue&type=template&id=42518fd6&scoped=true", function () {
      api.rerender('42518fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/carWashSuperviseSystem/carWashCentreManagement/modify.vue"
export default component.exports